import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
var INITIAL_STATE = {
  articleData: undefined,
  isLoading: false
};
var _createContextStore = createContextStore(INITIAL_STATE),
  useArticleContextStore = _createContextStore.useStore,
  ArticleContextProvider = _createContextStore.Provider;
export { ArticleContextProvider, useArticleContextStore };